import { Button, Stack } from "@altimateai/lego";
import { IconSparkles } from "@tabler/icons-react";
import {
  getDateByEndOfDayWithoutTimeoffset,
  getDateByStartOfDayWithoutTimeoffset,
} from "@/components/dateRange/utils";
import { useGlobalPlaygroundActions } from "@/modules/playground";

interface Props {
  costType: string;
  startDate: Date;
  endDate: Date | null;
  aggregation: string;
}

const getCostTypeLabel = (costType: string): string => {
  if (costType === "overall") return "overall";
  if (costType === "ai_services") return "AI services";
  return costType.replace(/_/g, " ");
};

const CostChartSuggestions = ({ costType, startDate, endDate, aggregation }: Props) => {
  const { openPlayground } = useGlobalPlaygroundActions();
  const label = getCostTypeLabel(costType);

  const suggestions = [
    `Show me ${label} cost projections for next quarter`,
    "Build a custom forecast model",
  ];

  const handleClick = (suggestion: string) => {
    openPlayground({
      chatbotProps: { initialMessage: suggestion },
      context: {
        chartType: "current",
        analysisType: "cost",
        costType,
        startDate: getDateByStartOfDayWithoutTimeoffset(startDate).toISOString(),
        endDate: getDateByEndOfDayWithoutTimeoffset(endDate)?.toISOString(),
        aggregation,
      },
    });
  };

  return (
    <div className="al-pt-3">
      <Stack direction="row" gap="sm">
        {suggestions.map(suggestion => (
          <Button
            key={suggestion}
            type="button"
            variant="outline"
            size="sm"
            onClick={() => handleClick(suggestion)}
          >
            <IconSparkles size={16} />
            {suggestion}
          </Button>
        ))}
      </Stack>
    </div>
  );
};

export default CostChartSuggestions;
